const Males = [
    { title: "Slicked Back", thumbnailUrl: "/images/Slicked Back-S.jpg", fullUrl: "/images/Slicked Back-L.jpg" },
    { title: "Faux Hawk Fade", thumbnailUrl: "/images/Faux Hawk Fade-S.jpg", fullUrl: "/images/Faux Hawk Fade-L.jpg" },
    { title: "Man Bob", thumbnailUrl: "/images/Man Bob-S.jpg", fullUrl: "/images/Man Bob-L.jpg" },
    { title: "Suft Cut", thumbnailUrl: "/images/Suft Cut-S.jpg", fullUrl: "/images/Suft Cut-L.jpg" },
    { title: "Spiky Style", thumbnailUrl: "/images/Spiky-S.jpg", fullUrl: "/images/Spiky-L.jpg" },
    { title: "Two Block", thumbnailUrl: "/images/Two Block-S.jpg", fullUrl: "/images/Two Block-L.jpg" },
    { title: "Undercut", thumbnailUrl: "/images/Undercut-S.jpg", fullUrl: "/images/Undercut-L.jpg" },
    { title: "Twist-out", thumbnailUrl: "/images/Twist-out-S.jpg", fullUrl: "/images/Twist-out-L.jpg" },
    { title: "Side Part", thumbnailUrl: "/images/Side-Part-S.jpg", fullUrl: "/images/Side-Part-L.jpg" }
  ];
  
  export default Males;